var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Component } from "react";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Icon, Icons } from "../../../atoms/icon";
import { Modal } from "../../../atoms/parental-control/components/modal";
import { HeaderVariants, Tags, Typography } from "../../../atoms/typography";
import { CustomPin } from "../components/customPin";
import { encryptMessage } from "../../../../utils/encrption";
import * as styles from "./../firstFlowModals/styles.css";
import { ErrorMessage } from "../components/errorMessage";
import { isHTMLInputElement } from "../../../../utils/common";
import { Checkbox } from "../../../../components/atoms/checkbox";
import { Button, ButtonVariant } from "../../../../components/atoms/button";
import Strings from "../../../../utils/hardcoded.json";
import { updateGlobalState } from "@discovery/common-dplus/lib/hooks";
import { Lens } from "@discovery/prelude/lib/control/lens";
import { cn } from "@discovery/classnames";
export class AllAccessLogin extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            pin1: "",
            pin2: "",
            pin3: "",
            pin4: "",
            isPinMatched: false,
            checked: false,
            encryptedValue: "",
            isPinValidated: false,
        };
        this.handleInput = (e) => {
            const target = e.target;
            if (isHTMLInputElement(target)) {
                const isnumber = /^-?\d*$/.test(target.value);
                if (isnumber) {
                    const inputvalue = target.value;
                    const name = target.name;
                    const partialState = {};
                    partialState[name] = inputvalue;
                    this.setState(partialState, () => {
                        this.checkPinValidation();
                    });
                }
            }
        };
        this.checkPinValidation = () => {
            const { pin1, pin2, pin3, pin4 } = this.state;
            const pin = pin1.concat(pin2, pin3, pin4);
            if (pin.length > 3) {
                this.encrypt(pin);
            }
        };
        this.onPinValidationSuccess = () => {
            const { checked, encryptedValue, isPinValidated, pin1, pin2, pin3, pin4 } = this.state;
            const pin = pin1.concat(pin2, pin3, pin4);
            const isPinEmpty = pin.length > 3;
            if (checked && isPinValidated && isPinEmpty) {
                this.props.onContinue(encryptedValue);
            }
        };
        this.onForgetPin = () => {
            this.props.forgotPin && this.props.forgotPin();
        };
        this.onBack = () => {
            const { timeOut, showAllAccessAfterTimeLock } = this.props;
            timeOut && showAllAccessAfterTimeLock
                ? this.props.onBackHandlerAfterTimeLock &&
                    this.props.onBackHandlerAfterTimeLock()
                : this.props.hideAllAccessPopup && this.props.hideAllAccessPopup();
            const setShowAllAccess = (accessState) => updateGlobalState(Lens.prop("isParentalLockAccess"))((_isParentalLockAccess) => accessState);
            setShowAllAccess(false);
        };
        this.toggleInput = () => {
            const { checked } = this.state;
            this.setState({ checked: !checked });
        };
    }
    encrypt(text) {
        return __awaiter(this, void 0, void 0, function* () {
            const encryptedValue = yield encryptMessage(text);
            if (encryptedValue === this.props.pinValidation) {
                this.setState({
                    encryptedValue,
                    isPinMatched: false,
                    isPinValidated: true,
                });
            }
            else {
                this.setState({ isPinMatched: true, isPinValidated: false });
            }
        });
    }
    render() {
        const { pin1, pin2, pin3, pin4, isPinMatched, checked, isPinValidated } = this.state;
        const pin = pin1.concat(pin2, pin3, pin4);
        const isPinEmpty = pin.length > 3;
        return (React.createElement(Modal, { label: Strings.ALL_ACCESS, showErrorMsg: isPinMatched, errorMsg: Strings.INCORRECT_PIN },
            React.createElement("div", { className: styles.loginCardContainer },
                React.createElement("div", { className: styles.createPinWrapper },
                    React.createElement("div", { className: styles.goBack, onClick: this.onBack, id: "backArrow" },
                        React.createElement(Icon, { type: Icons.LeftArrow, className: styles.backArrow, color: "white" })),
                    React.createElement("div", { className: styles.loginWrapper, id: "allAccessImage" },
                        React.createElement(Icon, { type: Icons.AllAccess, className: styles.image }))),
                React.createElement("div", { className: styles.pinWrapper, id: "yourPin" },
                    React.createElement(CustomPin, { label: "Your PIN", handleInput: this.handleInput, pin1: pin1, pin2: pin2, pin3: pin3, pin4: pin4, name: "pin", nextFocusID: "accessLoginContinueButton", autoFocus: pin1.length >= 1 ? false : true })),
                isPinMatched && React.createElement(ErrorMessage, { children: Strings.PIN_MISMATCH }),
                React.createElement("div", { className: cn(styles.forgotPinWrapper, {
                        [styles.pinMismatchDevider]: isPinMatched,
                    }), onClick: this.onForgetPin, id: "forgotPin" },
                    React.createElement(Typography, { classNameM: M.of(styles.forgotPin), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                        React.createElement(React.Fragment, null, Strings.FORGOT_PIN))),
                React.createElement("div", { className: styles.resetPinWrapper, onClick: this.props.resetPin, id: "resetPin" },
                    React.createElement(Typography, { classNameM: M.of(styles.forgotPin), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                        React.createElement(React.Fragment, null, Strings.RESET_PIN))),
                React.createElement("div", { className: styles.confirm, id: "ageConfirmation" },
                    React.createElement(Checkbox, { checked: checked, onClick: this.toggleInput }),
                    React.createElement(Typography, { classNameM: M.of(styles.searchTypeHeading1), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                        React.createElement(React.Fragment, null, Strings.CONFIRM))),
                React.createElement("div", { className: cn(styles.buttonWrapper, styles.spaceBottom), id: "ageConstraintContinueButton" },
                    React.createElement(Button, { id: "accessLoginContinueButton", children: Strings.CONTINUE, variant: checked && isPinValidated && isPinEmpty
                            ? ButtonVariant.Primary
                            : ButtonVariant.Disabled, onClickM: M.of(() => this.onPinValidationSuccess()) })))));
    }
}

